import { render, staticRenderFns } from "./NewOrderNotify.vue?vue&type=template&id=5309a8c6&scoped=true"
import script from "./NewOrderNotify.vue?vue&type=script&lang=js"
export * from "./NewOrderNotify.vue?vue&type=script&lang=js"
import style0 from "./NewOrderNotify.vue?vue&type=style&index=0&id=5309a8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309a8c6",
  null
  
)

export default component.exports